import {Record} from 'immutable';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';

export const PLAYLIST_MODE_TYPE = Object.freeze({
  ADD_CALLS: 'ADD_CALLS',
  VIEW_REVIEW: 'VIEW_REVIEW',
});

export const PLAYLIST_VISIBILITY = Object.freeze({
  shown: 'shown',
  hidden: 'hidden',
  peek: 'peek',
});

const initialState = Record({
  // Should the playlist be shown
  visibility: PLAYLIST_VISIBILITY.hidden,
  // Can we add calls to plans?
  canAddCalls: false,
  // The mode which the playlist is operating in
  // values are defined in the playlist component
  mode: undefined,
  // The relevant coaching plan Id
  planId: undefined,
  // User who is the plan recipient.
  recipient: undefined,
  // Whether to flash controls outside the playlist
  shouldFlash: false,
  // Should we flash the single card coaching controls when the
  // card is opened
  flashOnOpen: false,
  // are we currently viewing a plan/review? triggers a modified display
  currentlyViewing: false,
})();

@immutableStore
class CoachingPlaylistStore {
  constructor() {
    this.state = initialState;
    this.bindActions(CoachingPlaylistActions);
  }

  show() {
    this.setState({visibility: PLAYLIST_VISIBILITY.shown});
  }

  hide() {
    this.setState({visibility: PLAYLIST_VISIBILITY.hidden});
  }

  minimize() {
    this.setState({visibility: PLAYLIST_VISIBILITY.peek});
  }

  toggle() {
    const state =
      this.state.visibility === PLAYLIST_VISIBILITY.hidden
        ? PLAYLIST_VISIBILITY.shown
        : this.state.visibility === PLAYLIST_VISIBILITY.shown
        ? PLAYLIST_VISIBILITY.peek
        : PLAYLIST_VISIBILITY.shown;
    this.setState({visibility: state});
  }

  triggerFlash() {
    this.setState({
      shouldFlash: true,
    });
    setTimeout(() => {
      this.setState({shouldFlash: false});
    }, 3000);
  }

  // set up so that when the Card opens, we'll flash
  openWithFlash() {
    this.setState({
      flashOnOpen: true,
    });
  }

  // once we get the message, we'll reset the flag for later (probably not needed, but still)
  flashedOnOpen() {
    this.setState({
      flashOnOpen: false,
    });
  }

  setAddCallsMode({planId, recipient, keepState = false}) {
    if (keepState) {
      // only change mode
      return this.setState({
        mode: PLAYLIST_MODE_TYPE.ADD_CALLS,
      });
    }

    this.setState({
      visibility: PLAYLIST_VISIBILITY.shown,
      mode: PLAYLIST_MODE_TYPE.ADD_CALLS,
      planId,
      recipient,
    });
  }

  /**
   * Hooks up the appropriate plan id and changes the playlist "mode" to viewing the review.
   * Doesn't set visibility one way or the other - call visibility separately when you know
   * whether you need to show/hide/minimize.
   *
   * @param planId
   */
  setCurrentlyViewing({planId}) {
    this.setState({
      planId: planId,
      mode: PLAYLIST_MODE_TYPE.VIEW_REVIEW,
    });
  }

  setCanAddCalls(canAddCalls) {
    this.setState({canAddCalls});
  }

  reset() {
    this.setState(initialState);
  }
}

export default alt.createStore(CoachingPlaylistStore);
